import { render, staticRenderFns } from "./QingxuDuibi.vue?vue&type=template&id=78eb837c&"
import script from "./QingxuDuibi.vue?vue&type=script&lang=js&"
export * from "./QingxuDuibi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports